import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21f09d23"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile_layout_item" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "profile_title" }, "基本情報", -1))
const _hoisted_3 = { class: "profile_item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "氏名", -1))
const _hoisted_5 = { class: "profile_item_value" }
const _hoisted_6 = { class: "profile_item_value_text" }
const _hoisted_7 = { class: "profile_item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "フリガナ", -1))
const _hoisted_9 = { class: "profile_item_value" }
const _hoisted_10 = { class: "profile_item_value_text" }
const _hoisted_11 = { class: "profile_item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "性別", -1))
const _hoisted_13 = { class: "profile_item_value" }
const _hoisted_14 = { class: "profile_item_value_text" }
const _hoisted_15 = { class: "profile_item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "生年月日", -1))
const _hoisted_17 = { class: "profile_item_value" }
const _hoisted_18 = { class: "profile_item_value_text" }
const _hoisted_19 = { class: "profile_item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "携帯電話番号", -1))
const _hoisted_21 = { class: "profile_item_value" }
const _hoisted_22 = { class: "profile_item_value_text" }
const _hoisted_23 = { class: "profile_item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "住所", -1))
const _hoisted_25 = { class: "profile_item_value" }
const _hoisted_26 = { class: "profile_item_value_text" }
const _hoisted_27 = { class: "profile_item_value_text" }
const _hoisted_28 = { class: "profile_item_value_text" }
const _hoisted_29 = { class: "profile_button" }
const _hoisted_30 = { class: "profile_button_inner" }
const _hoisted_31 = { class: "profile_layout_item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "profile_title" }, "メールアドレス", -1))
const _hoisted_33 = { class: "profile_item" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "メールアドレス", -1))
const _hoisted_35 = { class: "profile_item_value" }
const _hoisted_36 = { class: "profile_item_value_text" }
const _hoisted_37 = { class: "profile_button" }
const _hoisted_38 = { class: "profile_button_inner" }
const _hoisted_39 = /*#__PURE__*/_createStaticVNode("<div class=\"profile_layout_item\" data-v-21f09d23><h2 class=\"profile_title\" data-v-21f09d23>パスワード</h2><div class=\"profile_item\" data-v-21f09d23><div class=\"profile_item_title\" data-v-21f09d23>パスワード</div><div class=\"profile_item_value\" data-v-21f09d23><p class=\"profile_item_value_text\" data-v-21f09d23>●●●●●●</p></div></div></div>", 1)
const _hoisted_40 = { class: "profile_button" }
const _hoisted_41 = { class: "profile_button_inner" }

import { toRefs } from 'vue';
import BaseButton from '@/components/BaseButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Profile',
  props: {
  fullName: {
    type: String,
    required: true,
  },
  fullNameKana: {
    type: String,
    required: true,
  },
  sex: {
    type: String,
    required: true,
  },
  birthday: {
    type: String,
    required: true,
  },
  telCellular: {
    type: String,
    required: true,
  },
  zipCode: {
    type: String,
    required: true,
  },
  pref: {
    type: String,
    required: true,
  },
  addr1: {
    type: String,
    required: true,
  },
  addr2: {
    type: String,
    required: true,
  },
  addr3: {
    type: String,
    required: true,
  },
  email: {
    type: String,
    required: true,
  },
},
  emits: ["transitionEditBasicPage", "transitionEditMailPage", "transitionEditPasswordPage"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'transitionEditBasicPage'): true;
  (e: 'transitionEditMailPage'): true;
  (e: 'transitionEditPasswordPage'): true;
}), expose: any, slots: any, attrs: any }) {

const props = __props



const { fullName, fullNameKana, sex, birthday, telCellular, zipCode, pref, addr1, addr2, addr3, email } = toRefs(props);


const transitionEditBasicPage = () => {
  emits('transitionEditBasicPage');
};

const transitionEditMailPage = () => {
  emits('transitionEditMailPage');
};

const transitionEditPasswordPage = () => {
  emits('transitionEditPasswordPage');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(fullName)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(fullNameKana)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(sex)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(birthday)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(telCellular)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("p", _hoisted_26, _toDisplayString(_unref(zipCode)), 1),
          _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(pref)) + " " + _toDisplayString(_unref(addr1)) + _toDisplayString(_unref(addr2)), 1),
          _createElementVNode("p", _hoisted_28, _toDisplayString(_unref(addr3)), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createVNode(BaseButton, {
          theme: "secondary",
          onClick: transitionEditBasicPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("基本情報を変更する")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _hoisted_32,
      _createElementVNode("div", _hoisted_33, [
        _hoisted_34,
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("p", _hoisted_36, _toDisplayString(_unref(email)), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _createVNode(BaseButton, {
          theme: "secondary",
          onClick: transitionEditMailPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("メールアドレスを変更する")
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_39,
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("div", _hoisted_41, [
        _createVNode(BaseButton, {
          theme: "secondary",
          onClick: transitionEditPasswordPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("パスワードを変更する")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})